// frontend/src/lib/zoteroUploadQueue.ts
export interface UploadQueueOpts<T> {
  items: T[];
  concurrency: number;
  uploadOne: (item: T) => Promise<void>;
  onProgress: (done: number, total: number) => void;
}
export interface UploadQueueResult { succeeded: number; failed: number; }

/** Run uploads with bounded concurrency; one failure never aborts the rest. */
export async function runUploadQueue<T>(
  opts: UploadQueueOpts<T>,
): Promise<UploadQueueResult> {
  const { items, concurrency, uploadOne, onProgress } = opts;
  const total = items.length;
  let done = 0, succeeded = 0, failed = 0, cursor = 0;

  async function worker() {
    while (cursor < items.length) {
      const item = items[cursor++];
      try {
        await uploadOne(item);
        succeeded++;
      } catch {
        failed++;
      } finally {
        done++;
        onProgress(done, total);
      }
    }
  }
  await Promise.all(
    Array.from({ length: Math.min(concurrency, total) }, () => worker()),
  );
  return { succeeded, failed };
}
